<template>
    <div>
        <div v-for="(pointer, index) in pointers" class="pointer" :style="{left: pointer.leftpos+'%', top: pointer.toppos+'%'}">
            <a href="#" class="icon" @click.prevent="togglePointer(index)"></a>
            <div class="infowindow" v-show="index == activeWindow">
                <h3>{{ pointer.title }}</h3>
                <h4>{{ pointer.subtitle }}</h4>
                <div class="content">
                    <p>{{ pointer.content }}</p>
                    <a class="button cta_red" :href="pointer.link">Bekijk</a>
                </div>
                <a href="#" class="close" @click.prevent="activeWindow = null"></a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'pointerlist',
        created() {
            this.fetchData()
        },
        data () {
            return {
                show: false,
                activeWindow: null,
                pointers: []
            }
        },
        methods: {
            fetchData () {
                this.$axios.get('/get/markersTrade?site_id='+this.$root.site_id)
                    .then(response => {
                        this.pointers = response.data
                    })
                    .catch(function (error) {
                        // console.log(error)
                    })
            },
            togglePointer (index) {
                if (this.activeWindow === index) {
                    this.activeWindow = null
                } else {
                    this.activeWindow = index
                }
            }
        }
    }
</script>
